export default "__VITE_PUBLIC_ASSET__2b87479f__"